import React, { useState } from "react"
import { Select } from "@lrewater/lre-react"
import LreReactLayout from "./LreReactLayout"

const SelectExample = props => {
  const [value, setValue] = useState(2)

  const data = [
    { ndx: 1, display: "Option 1" },

    { ndx: 2, display: "Option 2" },

    { ndx: 3, display: "Option 3" },
  ]

  const handleChange = event => {
    const newValue = event.target.value
    setValue(newValue)
  }

  return (
    <LreReactLayout>
      <Select
        name="standard_select"
        label="Standard"
        valueField="ndx"
        displayField="display"
        data={data}
        value={value}
        onChange={handleChange}
      />
      <Select
        name="filled_select"
        label="Filled"
        variant="filled"
        valueField="ndx"
        displayField="display"
        data={data}
        value={value}
        onChange={handleChange}
      />
      <Select
        name="outlined_select"
        label="Outlined"
        variant="outlined"
        valueField="ndx"
        displayField="display"
        data={data}
        value={value}
        onChange={handleChange}
      />
    </LreReactLayout>
  )
}

export default SelectExample
